const pricingFormat = (value) => {
  let parts = value.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export default class ProductItemsService {
  getItemsCount() {
    let cartItemsCount = 0;

    if (this.props.cart?.cartItems) {
      cartItemsCount = this.props.cart.cartItems.length;
    } else if (this.props.order?.orderItems) {
      cartItemsCount = this.props.order.orderItems.length;
    }
    return cartItemsCount;
  }

  getCartItemsCount(cart, order) {
    let cartItemsCount = 0;

    if (cart && Object.keys(cart).length > 0 && cart.cartItems) {
      cartItemsCount = cart.cartItems.length;
    } else if (order && Object.keys(order).length > 0) {
      cartItemsCount = order.orderItems.length;
    }
    return cartItemsCount;
  }
}

export { pricingFormat };
